if (!customElements.get('product-image-gallery')) {
  customElements.define('product-image-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const slides = [...this.querySelectorAll('[data-gallery-slide]')];
      const buttons = [...this.querySelectorAll('[data-gallery-thumbnail]')];
      if (!buttons.length) return;
      const select = (index) => {
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        buttons.forEach((button, i) => { button.setAttribute('aria-pressed', String(i === index)); });
        this.querySelector('[data-gallery-status]').textContent = `Image ${index + 1} of ${slides.length}`;
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(index));
        button.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(next);
          buttons[next].focus();
        });
      });
      select(0);
      this.querySelector('.product-gallery__thumbnails').hidden = false;
    }
  });
}
